import { Get, Post } from '@/backend/services/base/baseAjax';
import Vue from 'vue';

function dataListCreate({
	searchConfig,
	sort,
	init,
	getQuery,
	afterResponse,
	customName,
	setExtension,
}) {
	let getBody = function ({ self, getQuery, page = undefined, pageSize = undefined }) {
		setValueByProp(self, 'pageSize', 'page', pageSize);
		setValueByProp(self, 'currentPage', 'page', page);
		let baseParams = Object.assign(
			{},
			{
				displayStart: page,
				displayLength: pageSize,
				sortName: self.sort && self.sort.sortName ? self.sort.sortName : undefined,
				sortType: self.sort && self.sort.sortType ? self.sort.sortType : undefined,
				customerId: self.CUSTOMER,
			},
			self.filterParams
		);
		let _body = getQuery ? getQuery(baseParams, self) : baseParams;
		return _body;
	};

	let getValueByProp = function (self, prop, path) {
		return self[path][prop];
	};

	let setValueByProp = function (self, prop, path, value) {
		if (prop && prop.length) {
			Vue.set(self[path], prop, value);
		} else {
			Vue.set(self, path, value);
		}
	};
	return createListQueryWithPrefix(afterResponse, searchConfig.method == 'GET');

	function createListQueryWithPrefix(afterResponse, isGet) {
		function _afterResponse(res) {
			setValueByProp(this, '', 'data', res.data.data || res.data.results);
			if (res.data.page) {
				setValueByProp(this, 'totalRecords', 'page', res.data.page.totalRecords);
			}
		}

		let search = ({ self, query, afterResponse, isGet }) => {
			self.loading = true;
			let extension = setExtension ? setExtension(self, query) : {};
			let getOrPost;

			if (self.searchConfig.api) {
				getOrPost = isGet
					? Get({ url: self.searchConfig.api, ...extension })
					: Post({
							url: self.searchConfig.api,
							bodyParam: query,
							config: searchConfig.config,
							...extension,
					  });
			}
			if (self.searchConfig.customApi) {
				getOrPost = isGet
					? Get({ url: self.searchConfig.customApi(self), ...extension })
					: Post({
							url: self.searchConfig.customApi(self),
							bodyParam: query,
							config: searchConfig.config,
							...extension,
					  });
			}
			// 列表数据
			return getOrPost
				.then(res => {
					if (afterResponse) {
						let result = afterResponse.call(self, res, self);
						_afterResponse.call(self, result);
					} else {
						_afterResponse.call(self, res);
					}
				})
				.catch(() => {
					self.data = [];
					self.page = {};
				})
				.finally(() => {
					self.loading = false;
				});
		};
		return {
			data: function () {
				if (!customName) {
					return {
						searchConfig: searchConfig,
						data: [],
						page: {
							currentPage: 1,
							totalRecords: 0,
							pageSize: 10,
						},
						filterParams: {},
						sort: {},
						loading: false,
					};
				} else {
					return {
						[customName]: {
							searchConfig: searchConfig,
							data: [],
							page: {
								currentPage: 1,
								totalRecords: 0,
								pageSize: 10,
							},
							filterParams: {},
							sort: {},
							loading: false,
							pageSizeChanged: val => {
								return this.pageSizeChanged(val, customName);
							},
							pageChanged: val => {
								return this.pageChanged(val, customName);
							},
							query: () => {
								return this.query(customName);
							},
							sortChange: (source, prop, order) => {
								return this.sortChange(source, prop, order, customName);
							},
							filterChange: val => {
								return this.filterChange(val, customName);
							},
							filterValChange: val => {
								return this.filterValChange(val, customName);
							},
							resetPage: () => {
								return this.resetPage(customName);
							},
						},
					};
				}
			},
			methods: {
				pageSizeChanged: function (val, custom) {
					let self = custom ? this[custom] : this;
					self.resetPage(custom);
					let body = getBody({
						self: self,
						getQuery: getQuery,
						page: getValueByProp(self, 'currentPage', 'page'),
						pageSize: val,
						sort: sort ? self.sort : null,
					});
					return search({
						self: self,
						query: body,
						afterResponse: afterResponse,
						isGet: isGet,
					});
				},
				pageChanged: function (val, custom) {
					let self = custom ? this[custom] : this;
					let body = getBody({
						self: self,
						getQuery: getQuery,
						page: val,
						pageSize: getValueByProp(self, 'pageSize', 'page'),
						sort: sort ? self.sort : null,
					});
					return search({
						self: self,
						query: body,
						afterResponse: afterResponse,
						isGet: isGet,
					});
				},
				query: function (custom, isResetPage) {
					if (isResetPage) this.resetPage();

					let self = custom ? this[custom] : this;
					let body = getBody({
						self: self,
						getQuery: getQuery,
						page: getValueByProp(self, 'currentPage', 'page'),
						pageSize: getValueByProp(self, 'pageSize', 'page'),
						sort: sort ? self.sort : null,
					});
					return search({
						self: self,
						query: body,
						afterResponse: afterResponse,
						isGet: isGet,
					});
				},
				sortChange: function (source, prop, order, custom) {
					let self = custom ? this[custom] : this;
					self.sort.sortName =
						source && source.sort
							? source.sort
							: source && source.column
							? source.column.sortable
							: undefined;
					self.sort.sortType = source && source.column ? source.order : undefined;
					let body = getBody({
						self: self,
						getQuery: getQuery,
						page: 1,
						pageSize: getValueByProp(self, 'pageSize', 'page'),
						sort: self.sort,
					});
					return search({
						self: self,
						query: body,
						afterResponse: afterResponse,
						isGet: isGet,
					});
				},
				filterChange: function (val, custom) {
					let self = custom ? this[custom] : this;
					self.filterParams = Object.assign({}, val);
					self.resetPage(custom);
					self.query();
				},
				filterValChange(val, custom) {
					let self = custom ? this[custom] : this;
					self.filterParams = Object.assign({}, val);
					self.query();
				},
				resetPage(custom) {
					let self = custom ? this[custom] : this;
					self.page.currentPage = 1;
				},
			},
			mounted: function () {
				if (init) {
					init().then(() => {
						// this[queryPrefix]()
					});
				} else {
					// this[queryPrefix]()
				}
			},
		};
	}
}

export default dataListCreate;
